import { Divider, ListItem, ListItemText, Menu, MenuItem, Typography } from '@mui/material';
import { Fragment, MouseEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { DisabledCardMenu } from 'shell/view-models/disabled-menu';

interface CardMenuProps {
  visibility?: DisabledCardMenu;
  onClick: (event: MouseEvent<HTMLElement>) => void;
  onClose: (event: MouseEvent) => void;
  submenuAnchor: Element | null;
  isSubmenuVisible: boolean;
}

const CardMenu = ({
  visibility = {
    rilascioCarta: true,
    ristampaCid: true,
    registrazioneCarta: true,
    annullamentoCarta: true,
    gestioneLotti: true,
    recuperoCartelliniCie: true,
  },
  onClick,
  onClose,
  isSubmenuVisible,
  submenuAnchor,
}: CardMenuProps): React.ReactElement => {
  const navigate = useNavigate();

  return (
    <Fragment>
      <ListItem onClick={onClick}>
        <ListItemText primary="Carta d'identità" />
      </ListItem>
      <Menu
        id="card-menu"
        anchorEl={submenuAnchor}
        open={isSubmenuVisible}
        onClose={onClose}
        PaperProps={{
          style: {
            width: '30ch',
          },
        }}
      >
        {visibility.rilascioCarta
          ? [
              <MenuItem
                key="rilascioCarta-menu-item"
                onClick={(event) => {
                  onClose(event);
                  navigate('/sportello/rilascio-carta');
                }}
              >
                <Typography variant="inherit">{"Rilascio Carta d'identità"}</Typography>
              </MenuItem>,
              <Divider
                key="rilascioCarta-divider"
                hidden={
                  !visibility.ristampaCid &&
                  !visibility.registrazioneCarta &&
                  !visibility.annullamentoCarta &&
                  !visibility.gestioneLotti &&
                  !visibility.recuperoCartelliniCie
                }
              />,
            ]
          : undefined}
        {visibility.ristampaCid
          ? [
              <MenuItem
                key="ristampaCid-item"
                onClick={(event) => {
                  onClose(event);
                  navigate('/sportello/ristampa-carta/ricerca-persona');
                }}
              >
                <Typography variant="inherit">Stampa busta CIE</Typography>
              </MenuItem>,
              <Divider
                key="ristampaCid-divider"
                hidden={
                  !visibility.registrazioneCarta &&
                  !visibility.annullamentoCarta &&
                  !visibility.gestioneLotti &&
                  !visibility.recuperoCartelliniCie
                }
              />,
            ]
          : undefined}
        {visibility.registrazioneCarta
          ? [
              <MenuItem
                key="registrazioneCarta-item"
                onClick={(event) => {
                  onClose(event);
                  navigate('/sportello/registrazione-carta');
                }}
              >
                <Typography variant="inherit">Registrazione Carta</Typography>
              </MenuItem>,
              <Divider
                key="registrazioneCarta-divider"
                hidden={
                  !visibility.annullamentoCarta &&
                  !visibility.gestioneLotti &&
                  !visibility.recuperoCartelliniCie
                }
              />,
            ]
          : undefined}
        {visibility.annullamentoCarta
          ? [
              <MenuItem
                key="annullamentoCarta-item"
                onClick={(event) => {
                  onClose(event);
                  navigate('/sportello/annullamento-carta');
                }}
              >
                <Typography variant="inherit">Annullamento Carta</Typography>
              </MenuItem>,
              <Divider
                key="annullamentoCarta-divider"
                hidden={!visibility.gestioneLotti && !visibility.recuperoCartelliniCie}
              />,
            ]
          : undefined}
        {visibility.gestioneLotti
          ? [
              <MenuItem
                key="gestioneLotti-item"
                onClick={(event) => {
                  onClose(event);
                  navigate('/sportello/gestione-lotti');
                }}
              >
                <Typography variant="inherit">Gestione Lotti</Typography>
              </MenuItem>,
              <Divider key="gestioneLotti-divider" hidden={!visibility.recuperoCartelliniCie} />,
            ]
          : undefined}
        {visibility.recuperoCartelliniCie
          ? [
              <MenuItem
                key="recuperoCartelliniCie-item"
                onClick={(event) => {
                  onClose(event);
                  navigate('/sportello/recupero-cie');
                }}
              >
                <Typography variant="inherit">Recupero cartellini CIE</Typography>
              </MenuItem>,
            ]
          : undefined}
      </Menu>
    </Fragment>
  );
};

CardMenu.displayName = 'Card ID Menu';

export default CardMenu;
